import { mergeStyleSets, useTheme } from '@fluentui/react';

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    accountList: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    account: {
      padding: '4px 0',
      display: 'grid',
      cursor: 'pointer',
      gridTemplateColumns: '54px 1fr auto',
      '&:hover': {
        backgroundColor: theme.semanticColors.buttonBackgroundHovered,
      },
      '& .providerLogo': {
        alignSelf: 'center',
        justifySelf: 'center',
        filter: 'saturate(85%)',
      },
      '& .removeButton': {
        alignSelf: 'center',
        margin: '0 8px',
        color: theme.palette.neutralTertiaryAlt,
      },
      '& .removeButton:hover': {
        backgroundColor: theme.semanticColors.buttonBackgroundCheckedHovered,
      },
      '&:hover .removeButton': {
        color: theme.palette.neutralTertiary,
      },
      '& .removeButtonContainer': {
        display: 'inline-flex',
        alignItems: 'center',
        alignSelf: 'center',
      },
    },
    accountActive: {
      '& .name': {
        fontWeight: 600,
      },
    },
    loginInfo: {
      alignSelf: 'center',
      flexDirection: 'column',
      '& .name': {
        alignSelf: 'center',
        marginBottom: '2px',
      },
      '& .providerName': {
        alignSelf: 'center',
        color: theme.palette.neutralSecondaryAlt,
      },
    },
  });
};
